// extracted by mini-css-extract-plugin
export default {"divorceSteps":"DivorceStep_divorceSteps__C2Ud3","nextStep":"DivorceStep_nextStep__6Qpyn","guidesWrap":"DivorceStep_guidesWrap__pGRGg"};